import React from 'react';

const MuscleIcon = ({ type, size = 64 }) => {
  const commonProps = {
    width: size,
    height: size,
    viewBox: "0 0 100 100",
    fill: "none",
    stroke: "#a89fcf", // Light purple accent for lines
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: { display: 'block', margin: '0 auto' }
  };

  const bgFill = "#2c2443"; // Dark purple background for solid shapes
  const accentFill = "#a89fcf"; // Light purple for highlights

  switch (type) {
    case 'Épaules':
      return (
        <svg {...commonProps}>
          {/* Torso */}
          <path d="M30 40 Q50 30 70 40 L65 80 L35 80 Z" fill={bgFill} />
          {/* Deltoids prominent */}
          <path d="M15 45 Q20 30 35 35 Q30 50 15 45" fill={accentFill} stroke="none" />
          <path d="M85 45 Q80 30 65 35 Q70 50 85 45" fill={accentFill} stroke="none" />
          <path d="M15 45 Q20 30 35 35 M85 45 Q80 30 65 35" strokeWidth="3" />
        </svg>
      );
    case 'Biceps':
      return (
        <svg {...commonProps}>
          {/* Arm frame */}
          <path d="M20 80 L35 45 L75 45" strokeWidth="6" />
          {/* Bicep bump */}
          <path d="M35 45 Q55 15 70 45" fill={accentFill} stroke="none" />
          <path d="M35 45 Q55 15 70 45" strokeWidth="3" />
          {/* Fist */}
          <circle cx="80" cy="45" r="6" fill={bgFill} stroke={accentFill} strokeWidth="2" />
        </svg>
      );
    case 'Avant-bras':
      return (
        <svg {...commonProps}>
          {/* Upper arm flat */}
          <path d="M10 50 L40 50" strokeWidth="4" />
          {/* Forearm going up */}
          <path d="M40 50 L75 25" strokeWidth="4" />
          {/* Forearm muscle bump on the bottom */}
          <path d="M40 50 Q75 60 75 25" fill={accentFill} stroke="none" />
          <path d="M40 50 Q75 60 75 25" strokeWidth="3" />
          {/* Hand/Fist */}
          <circle cx="80" cy="20" r="6" fill={bgFill} stroke={accentFill} strokeWidth="2" />
        </svg>
      );
    case 'Dos':
      return (
        <svg {...commonProps}>
          {/* V-Taper back */}
          <path d="M20 20 L80 20 L60 80 L40 80 Z" fill={bgFill} />
          {/* Lats */}
          <path d="M20 20 Q10 40 30 60" strokeWidth="3" />
          <path d="M80 20 Q90 40 70 60" strokeWidth="3" />
          {/* Spine and traps */}
          <line x1="50" y1="20" x2="50" y2="80" strokeDasharray="5 5" />
          <path d="M35 20 L50 40 L65 20" />
        </svg>
      );
    case 'Triceps':
      return (
        <svg {...commonProps}>
          {/* Flexed arm pointing down */}
          <path d="M20 20 L50 20 L50 70" strokeWidth="6" />
          {/* Triceps bump on the outside */}
          <path d="M50 25 Q80 30 50 60" fill={accentFill} stroke="none" />
          <path d="M50 25 Q80 30 50 60" strokeWidth="3" />
          {/* Fist */}
          <circle cx="50" cy="75" r="6" fill={bgFill} stroke={accentFill} strokeWidth="2" />
        </svg>
      );
    case 'Pectoraux':
      return (
        <svg {...commonProps}>
          <path d="M20 30 Q50 20 80 30 L70 80 L30 80 Z" fill={bgFill} />
          {/* Pec outlines */}
          <path d="M20 30 Q50 50 50 80" />
          <path d="M80 30 Q50 50 50 80" />
          <path d="M25 50 Q40 60 45 50" fill={accentFill} stroke="none" />
          <path d="M75 50 Q60 60 55 50" fill={accentFill} stroke="none" />
        </svg>
      );
    case 'Abdos':
      return (
        <svg {...commonProps}>
          <rect x="30" y="20" width="40" height="60" rx="10" fill={bgFill} />
          <line x1="50" y1="20" x2="50" y2="80" strokeWidth="3" />
          {/* 6 pack horizontal lines */}
          <line x1="30" y1="40" x2="70" y2="40" strokeWidth="3" />
          <line x1="30" y1="60" x2="70" y2="60" strokeWidth="3" />
          {/* Highlights */}
          <rect x="35" y="25" width="10" height="10" rx="3" fill={accentFill} stroke="none" />
          <rect x="55" y="25" width="10" height="10" rx="3" fill={accentFill} stroke="none" />
        </svg>
      );
    case 'Jambes':
    case 'Quadriceps':
    case 'Quadri':
      return (
        <svg {...commonProps}>
          {/* Waist */}
          <path d="M30 20 L70 20 L60 40 L40 40 Z" fill={bgFill} />
          {/* Quads */}
          <path d="M30 20 Q10 50 35 80 L45 80 L40 40 Z" fill={accentFill} stroke="none" />
          <path d="M70 20 Q90 50 65 80 L55 80 L60 40 Z" fill={accentFill} stroke="none" />
          <path d="M30 20 Q10 50 35 80 M70 20 Q90 50 65 80" strokeWidth="3" />
        </svg>
      );
    case 'Ischio-jambiers':
    case 'Ischios':
      return (
        <svg {...commonProps}>
          {/* Waist */}
          <path d="M30 20 L70 20 L60 40 L40 40 Z" fill={bgFill} />
          {/* Ischios (back of the leg highlighted) */}
          <path d="M40 40 L40 80 L50 80 Q45 60 45 40 Z" fill={accentFill} stroke="none" />
          <path d="M60 40 L60 80 L50 80 Q55 60 55 40 Z" fill={accentFill} stroke="none" />
          <path d="M30 20 Q10 50 35 80 M70 20 Q90 50 65 80" strokeWidth="3" />
        </svg>
      );
    case 'Mollets':
      return (
        <svg {...commonProps}>
          {/* Lower legs */}
          <line x1="40" y1="20" x2="40" y2="90" strokeWidth="4" />
          <line x1="60" y1="20" x2="60" y2="90" strokeWidth="4" />
          {/* Calf muscles highlighted */}
          <path d="M40 30 Q25 45 40 60" fill={accentFill} stroke="none" />
          <path d="M60 30 Q75 45 60 60" fill={accentFill} stroke="none" />
          <path d="M40 30 Q25 45 40 60 M60 30 Q75 45 60 60" strokeWidth="3" />
        </svg>
      );
    case 'Cou':
      return (
        <svg {...commonProps}>
          {/* Shoulders */}
          <path d="M10 80 Q30 70 40 60 L60 60 Q70 70 90 80" strokeWidth="4" />
          {/* Thick neck highlighted */}
          <path d="M35 60 L38 30 L62 30 L65 60 Z" fill={accentFill} stroke="none" />
          <path d="M35 60 L38 30 M65 60 L62 30" strokeWidth="3" />
          {/* Head silhouette */}
          <path d="M38 30 Q30 5 50 5 Q70 5 62 30 Z" fill={bgFill} stroke={accentFill} strokeWidth="2" />
        </svg>
      );
    case 'Fessier':
      return (
        <svg {...commonProps}>
          {/* Glutes from behind */}
          <path d="M20 30 L80 30 L70 90 Q50 100 50 60 Q50 100 30 90 Z" fill={bgFill} />
          <path d="M30 40 Q10 60 35 80" fill={accentFill} stroke="none" />
          <path d="M70 40 Q90 60 65 80" fill={accentFill} stroke="none" />
          <path d="M30 40 Q10 60 35 80 M70 40 Q90 60 65 80" strokeWidth="3" />
          <line x1="50" y1="30" x2="50" y2="90" strokeWidth="3" />
        </svg>
      );
    case 'Callisthénie':
      return (
        <svg {...commonProps}>
          {/* Vertical Pole */}
          <line x1="30" y1="10" x2="30" y2="90" strokeWidth="6" />
          {/* Human Flag */}
          {/* Head */}
          <circle cx="50" cy="50" r="8" fill={accentFill} stroke="none" />
          {/* Torso & Legs */}
          <line x1="58" y1="50" x2="95" y2="50" strokeWidth="5" />
          {/* Top Arm */}
          <line x1="30" y1="30" x2="45" y2="50" strokeWidth="3" />
          {/* Bottom Arm */}
          <line x1="30" y1="70" x2="45" y2="50" strokeWidth="3" />
        </svg>
      );
    case 'Cardio':
      return (
        <svg {...commonProps}>
          <path 
            d="M50,90 C5,55 5,20 25,15 C38,10 50,25 50,25 C50,25 62,10 75,15 C95,20 95,55 50,90 Z" 
            fill={bgFill} 
            stroke={accentFill} 
            strokeWidth="3" 
          />
          <polyline 
            points="20,45 32,45 42,25 55,65 65,45 80,45" 
            fill="none" 
            stroke="#fff" 
            strokeWidth="3" 
            strokeLinejoin="round" 
          />
        </svg>
      );
    default:
      return (
        <svg {...commonProps}>
          {/* Main central barbell bar */}
          <line x1="20" y1="50" x2="80" y2="50" strokeWidth="5" stroke={accentFill} strokeLinecap="round" />
          {/* Left inner plate */}
          <rect x="28" y="32" width="6" height="36" rx="2" fill={bgFill} stroke={accentFill} strokeWidth="2.5" />
          {/* Left outer plate */}
          <rect x="18" y="24" width="7" height="52" rx="2.5" fill={bgFill} stroke={accentFill} strokeWidth="2.5" />
          {/* Right inner plate */}
          <rect x="66" y="32" width="6" height="36" rx="2" fill={bgFill} stroke={accentFill} strokeWidth="2.5" />
          {/* Right outer plate */}
          <rect x="75" y="24" width="7" height="52" rx="2.5" fill={bgFill} stroke={accentFill} strokeWidth="2.5" />
          {/* Center knurled grip */}
          <line x1="42" y1="50" x2="58" y2="50" strokeWidth="8" stroke={accentFill} strokeDasharray="3 2" />
        </svg>
      );
  }
};

export default MuscleIcon;
